import React from 'react';
import { TableCell } from 'carbon-components-react';
import CompareField from './compare-field';
import CompareAddress from './compare-address';

const BeneficiaryTableRow = ({modified, unmodified}) => {
    const getType = (type) => {
        if(!type)
            return null;
        return type === 1 ? "Primary": "Contingent";
    }

    return ( 
        <>
            <TableCell className='p-4'>
                <CompareField modifiedValue={modified?.firstName} unmodifiedValue={unmodified?.firstName} />
            </TableCell>
            <TableCell className='p-4'>
                <CompareField modifiedValue={modified?.lastName} unmodifiedValue={unmodified?.lastName} />
            </TableCell>
            <TableCell className='p-4'>
                <CompareField modifiedValue={modified?.relationship?.name} unmodifiedValue={unmodified?.relationship?.name} />
            </TableCell>
            <TableCell className='p-4'>
                <CompareField modifiedValue={modified?.ssn} unmodifiedValue={unmodified?.ssn} mask={modified?.isEmployee || unmodified?.isEmployee} />
            </TableCell>
            <TableCell className='p-4'>
                <CompareAddress modified={modified?.address} unmodified={unmodified?.address} mask={modified?.isEmployee || unmodified?.isEmployee} />
            </TableCell>
            <TableCell className='p-4'>
                <CompareField modifiedValue={modified?.percentage} unmodifiedValue={unmodified?.percentage} />
            </TableCell>
            <TableCell className='p-4'>
                <CompareField modifiedValue={getType(modified?.type)} unmodifiedValue={getType(unmodified?.type)} />
            </TableCell>
        </>
     );
}
 
export default BeneficiaryTableRow;